import cornell from "../assets/icons/cornell.jpg";
import vjti from "../assets/icons/vjti.jpg";

const EducationData = [
  {
    universityIndex: 1,
    shortUniversityName: "cornell",
    universityName: "Cornell University",
    date: "August 2022 - May 2023",
    degree: "Master of Engineering in Computer Science",
    cgpa: "3.82/4",
    relevantCoursework: [
      "Introduction to Algorithm Analysis",
      "Foundations of Artificial Intelligence",
      "Business Intelligence Systems",
      "Management Consulting Essentials",
    ],
    icon: cornell,
    desc: "Working in the industry for a year, I understood my strengths and weaknesses. I decided that going back to academia is the best way to polish my skills. This M.Eng degree is an industry-focused professional degree that helps me grow in specialized areas that I wanted to focus on.",
  },
  {
    universityIndex: 2,
    shortUniversityName: "vjti",
    universityName: "VJTI",
    date: "August 2017 - May 2021",
    degree: "Bachelor of Technology in Information Technology",
    cgpa: "9.51/10",
    relevantCoursework: [
      "Design & Analysis of Algorithms",
      "Human Computer Interactions",
      "Cloud Computing",
      "Software Analysis and Design Patterns",
      "Multicore Technologies",
      "Operating Systems",
    ],
    icon: vjti,
    desc: "I graduated as the valedictorian of the class of 2021. My decision to pursue B.Tech in IT (CS) came from my interests in all things computers.",
  },
];

export default EducationData;
